<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>规则活动</span>
          <el-form ref="queryForm" style="margin-top: 10px" :model="queryParams" :inline="true">
            <el-form-item label="活动名称" prop="name">
              <el-input
                v-model="queryParams.name"
                placeholder="请输入活动名称"
                clearable
                size="small"
                style="width: 160px"
                @keyup.enter.native="handleQuery"
              />
            </el-form-item>
            <el-form-item label="状态" prop="status">
              <el-select
                v-model="queryParams.isOnline"
                placeholder="状态"
                clearable
                size="small"
                style="width: 160px"
              >
                <el-option
                  v-for="dict in statusType"
                  :key="dict.value"
                  :label="dict.label"
                  :value="dict.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="活动分类" prop="status">
              <el-select
                v-model="queryParams.type"
                filterable
                placeholder="活动分类"
                clearable
                size="small"
                style="width: 160px"
              >
                <el-option
                  v-for="dict in types"
                  :key="dict.value"
                  :label="dict.label"
                  :value="dict.value"
                />
              </el-select>
            </el-form-item>

            <!--            <el-form-item label="活动类型" prop="status">-->
            <!--              <el-select-->
            <!--                v-model="queryParams.ucType"-->
            <!--                placeholder="活动类型"-->
            <!--                clearable-->
            <!--                size="small"-->
            <!--                style="width: 160px"-->
            <!--              >-->
            <!--                <el-option-->
            <!--                  v-for="dict in actType"-->
            <!--                  :key="dict.value"-->
            <!--                  :label="dict.label"-->
            <!--                  :value="dict.value"-->
            <!--                />-->
            <!--              </el-select>-->
            <!--            </el-form-item>-->
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
              <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
              <el-button
                v-permisaction="['config:activityCoins:add']"
                type="primary"
                icon="el-icon-plus"
                size="mini"
                style=""
                @click="edit(0)"
              >新增</el-button>
              <el-upload
                ref="upload"
                class="upload-demo"
                :action="sys_app_logoAction"
                accept="xlsx"
                :limit="1"
                :on-success="importUploadSuccess"
                :headers="headers"
                style="display: inline-block;margin-left: 10px"
              >
                <el-button v-permisaction="['config:rewardRankEdit:import']" :loading="loading" icon="el-icon-upload2" size="mini" type="primary">导入</el-button>
              </el-upload>
            </el-form-item>

            <el-button style="margin-top: 5px" size="mini" @click="onSubmit">保存</el-button>

          </el-form>
        </div>

        <el-table
          :data="tableData"
          border
          style="width: 100%"
        >

          <el-table-column
            prop="id"
            label="活动ID"
            align="center"
            width="100"
          />

          <el-table-column
            prop="name"
            label="活动名称"
            align="center"
          />

          <el-table-column
            prop="type"
            label="活动分类"
            :formatter="typeFormatter"
            align="center"
          />

          <el-table-column
            prop="start_time"
            label="开始时间"
            align="center"
          />

          <el-table-column
            prop="end_time"
            label="结束时间"
            align="center"
          />

          <el-table-column
            v-if="coupon_skin.length > 0"
            prop="imgName"
            label="皮肤"
            align="center"
          >
            <template slot-scope="props">
              <el-select v-model="props.row.imgName" filterable multiple placeholder="请选择">
                <el-option
                  v-for="item in coupon_skin"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>

            </template>
          </el-table-column>

          <el-table-column
            prop="is_online"
            label="状态"
            align="center"
          >
            <template slot-scope="props">
              <el-tag v-if="props.row.is_online === 0" type="danger">下线</el-tag>
              <el-tag v-if="props.row.is_online === 1">上线</el-tag>
            </template>
          </el-table-column>

          <el-table-column
            fixed="right"
            label="操作"
            align="center"
            width="350"
          >
            <template slot-scope="scope">
              <el-button v-permisaction="['config:activityRule:copy']" type="text" size="mini" @click="copy(scope.row.id)">拷贝</el-button>
              <el-button v-permisaction="['config:activityRule:edit']" type="text" size="mini" @click="edit(scope.row.id)">编辑</el-button>
              <el-button v-if="scope.row.id > 0" v-permisaction="['config:activityRule:config']" type="text" size="mini" @click="reward(scope.row.type,scope.row.id,scope.row.uc_type)">配置</el-button>
              <el-button v-if="scope.row.is_online === 0" v-permisaction="['config:activityRule:isOnline']" type="text" size="mini" @click="changeOnline(scope.row.id,1,scope.row.type,scope.row.priority)">上线</el-button>
              <el-button v-if="scope.row.is_online === 1" v-permisaction="['config:activityRule:isOnline']" type="text" size="mini" @click="changeOnline(scope.row.id,0,scope.row.type,scope.row.priority)">下线</el-button>
              <el-button v-permisaction="['config:activityRule:isOnline']" type="text" size="mini" @click="exportData(scope.row.id,scope.row.type)">导出</el-button>
              <el-button v-permisaction="['config:activityRule:del']" type="text" size="mini" @click="del(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <pagination
          v-show="total>0"
          background
          :page.sync="queryParams.pageIndex"
          :limit.sync="queryParams.pageSize"
          :total="total"
          @pagination="getTables"
        />
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getToken } from '@/utils/auth'
import {
  changeActivtyOnline,
  copyActivtyData,
  delActivtyCfg, exportActivtyRewardCfg,
  getActivtyList,
  getActivtyTypesList, importActivtyRewardCfg, updateActivtySkinCfg
} from '@/api/config/activity-cfg'
import { getActiveSkinTypeList } from '@/api/config/active-skin-cfg'
export default {
  name: 'RuleActivity',
  data() {
    return {
      loading: false,
      total: 0,
      headers: { 'Authorization': 'Bearer ' + getToken() },
      sys_app_logoAction: process.env.VUE_APP_BASE_API + '/api/v1/public/uploadFile',
      queryParams: {
        name: '',
        type: '',
        ucType: 1,
        isOnline: '',
        pageIndex: 1,
        pageSize: 10
      },
      tableData: [],
      types: [],
      statusType: [
        { label: '上线', value: 1 },
        { label: '下线', value: 0 }
      ],
      actType: [
        { label: '常模活动', value: 1 },
        { label: '道具活动', value: 2 },
        { label: '模板活动', value: 3 },
        { label: '循环活动', value: 4 }
      ],
      coupon_skin: [
        // { label: '默认', value: '0' },
        // { label: '披萨', value: '1' }
        // { label: '沙滩冲浪', value: '2' },
        // { label: '放风筝', value: '3' }
      ]
    }
  },
  created() {
    this.getTables()
    this.getActivtyTypes()
    this.$root.$on('fetchRuleData', this.fetchData)
  },
  methods: {
    resetQuery() {
      this.resetForm('queryForm')
      this.handleQuery()
    },
    handleQuery() {
      this.getTables()
    },
    fetchData() {
      this.getTables()
    },
    beforeDestroy() {
      this.$root.$off('fetchData', this.fetchData) // 取消监听 fetchData 事件
    },
    getActivtyTypes() {
      getActivtyTypesList().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            const val = res.data[i]
            this.types.push({ label: val, value: i })
          }
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      this.getActSkinTypeList(this.queryParams.type)
      getActivtyList(this.queryParams).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.list
          this.total = res.data.count
        } else {
          this.msgError(res.msg)
        }
      })
    },
    copy(id) {
      copyActivtyData({ id: id }).then(res => {
        if (res.code === 200) {
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    edit(id) {
      this.$router.push({ name: 'ActivityConfigEdit', query: { id: id, rule: 1 }})
    },
    reward(type, id, uc_type) {
      console.log(type)
      switch (type) {
        case 'super_collect':
        case 'super_collect2':
        case 'super_collect3':
          this.$router.push({ name: 'RewardCollectEdit', query: { id: id, type: type, uc_type: uc_type }})
          break
        case 'rank':
          this.$router.push({ name: 'RewardRankEdit', query: { id: id, type: type, uc_type: uc_type }})
          break
        case 'super_serial_pack':
        case 'super_serial_pack2':
        case 'super_serial_pack3':
        case 'super_serial_pack4':
          this.$router.push({ name: 'RewardSerialPack', query: { id: id, type: type, uc_type: uc_type }})
          break
        case 'coin_blast':
          this.$router.push({ name: 'RewardCoinBlastEdit', query: { id: id, type: type, uc_type: uc_type }})
          break
        case 'shop_promotion':
          this.$router.push({ name: 'RewardShopPromotionEdit', query: { id: id, type: type, uc_type: uc_type }})
          break
        case 'traffic_permit':
          this.$router.push({ name: 'rewardTrafficPermitEdit', query: { id: id, type: type, uc_type: uc_type }})
          break
        case 'spins_master':
          this.$router.push({ name: 'RewardSpinsMasterEdit', query: { id: id, type: type, uc_type: uc_type }})
          break
        case 'build_pack':
          this.$router.push({ name: 'rewardBuildPackEdit', query: { id: id, type: type, uc_type: uc_type }})
          break
        case 'easter_egg':
          this.$router.push({ name: 'RewardEggEdit', query: { id: id, type: type, uc_type: uc_type }})
          break
        case 'super_balloon':
          this.$router.push({ name: 'RewardSuperBalloonEdit', query: { id: id, type: type, uc_type: uc_type }})
          break
        case 'architecture':
          this.$router.push({ name: 'RewardBuilderMasterEdit', query: { id: id, type: type, uc_type: uc_type }})
          break
        case 'pick_one':
          this.$router.push({ name: 'RewardPickOneEdit', query: { id: id, type: type, uc_type: uc_type }})
          break
        case 'choose_one':
          this.$router.push({ name: 'rewardChooseOneEdit', query: { id: id, type: type, uc_type: uc_type }})
          break
        case 'one_plus_gift':
          this.$router.push({ name: 'RewardOnePlusGiftEdit', query: { id: id, type: type, uc_type: uc_type }})
          break
        case 'two_plus_gift':
          this.$router.push({ name: 'RewardTwoPlusGiftEdit', query: { id: id, type: type, uc_type: uc_type }})
          break
        case 'download_pack':
          this.$router.push({ name: 'RewardDownLoadPackEdit', query: { id: id, type: type, uc_type: uc_type }})
          break
        default:
          this.msgError('无配置')
          break
      }
    },
    del(id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delActivtyCfg({ id: id }).then(res => {
          if (res.code === 200) {
            this.msgSuccess(res.msg)
            this.getTables()
          } else {
            this.msgError(res.msg)
          }
        })
      })
    },
    changeOnline(id, status, type, priority) {
      changeActivtyOnline({ id: id, name: status, type: type, data: priority }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    clientFormatter(row) {
      const clientType = ['全部', '安卓', 'IOS']
      return clientType[row.client]
    }, userTypeFormatter(row) {
      const userType = ['全部', 'FB', '游客']
      return userType[row.user_type]
    }, loopTypeFormatter(row) {
      const loopType = ['', '单次', '小时', '天']
      return loopType[row.loop_type ]
    },
    typeFormatter(row) {
      let name = '未知类型'
      for (const i in this.types) {
        if (row.type === this.types[i].value) {
          name = this.types[i].label
          break
        }
      }
      return name
    },
    importUploadSuccess(response) {
      this.loading = true
      this.$refs['upload'].clearFiles()
      importActivtyRewardCfg({ type: this.queryParams.type, id: this.aid, data: response.data.path }).then(res => {
        // eslint-disable-next-line eqeqeq
        this.loading = false
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    }, exportData(id, type) {
      // console.log('type', type)
      exportActivtyRewardCfg({ id: id, type: type }).then(res => {
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getActSkinTypeList(typ) {
      this.coupon_skin = []
      if (typ === '') {
        return
      }

      getActiveSkinTypeList({ name: typ }).then(res => {
        this.coupon_skin.push({ label: '默认', value: '0' })
        if (res.code === 200) {
          res.data.forEach(item => {
            this.coupon_skin.push({ label: item.name, value: item.value })
          })
        } else {
          this.msgError(res.msg)
        }
      })
    },
    onSubmit() {
      const data = JSON.stringify(this.tableData)
      updateActivtySkinCfg({ type: this.queryParams.type, data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style>
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>
